import { useEffect } from 'react'
import { useNavigate, useParams, useLocation, Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import StoreBlock from './StoreBlock'
import StoreBreadcrumbs from './StoreBreadcrumbs'
import { getAssetLink } from './../../helpers/get-asset-link'

const StoreCategory = ({ children }) => {
  const navigate = useNavigate()
  const params = useParams()
  const location = useLocation()

  const products = useSelector((state) => state.shop.products) || []
  const _gifts = useSelector((state) => state.shop.gifts) || []

  useEffect(() => {
    if (params.name === 'gift' && !params.product) {
      navigate('/dashboard/store/category/gift/product/gift')
    }
  }, [params, navigate])

  const filteredProducts = products.filter((p) => p.categoryUrl === params.name)

  return (
    <div>
      <StoreBreadcrumbs />
      {children || (
        <div className="columns is-multiline">
          {filteredProducts.map((p) => (
            <Link
              key={p.id}
              to={`${location.pathname}/product/${p.productUrl}`}
              className="column is-6"
            >
              <StoreBlock
                title={p.name}
                image={getAssetLink({
                  path: 'chitown-default',
                  file: p.imageInCategory,
                })}
              />
            </Link>
          ))}
        </div>
      )}
    </div>
  )
}

StoreCategory.propTypes = {
  children: PropTypes.node,
}

export default StoreCategory
